import { render, staticRenderFns } from "./under_construction.vue?vue&type=template&id=41171717&"
import script from "./under_construction.vue?vue&type=script&lang=js&"
export * from "./under_construction.vue?vue&type=script&lang=js&"
import style0 from "./under_construction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports